import Vue from 'vue'

import previewPlugin from './preview/index'
const VuePlugins = [
    previewPlugin,
]
const app = {}
app.install = function(Vue, options) {
  VuePlugins.forEach(plugin=>{
    Vue.use(plugin, options, this)
  })
}
// 全局插件
Vue.use(app)

Vue.prototype.$plugins = app
